export default __webpack_public_path__ + "static/media/esrb-mature.88039669.svg";